import React from 'react'
import CommonOrder from '../commonorder/CommonOrder'

const MineOrder = () => {
  return (
    <>
    <CommonOrder/>
    <CommonOrder/>
    
    </>
  )
}

export default MineOrder